/* live-match (Robin 21 Oct): every underlined text link rises slightly on hover while the underline stays put
   (same behaviour as live .underlineAnimateUp / SIZE CHART). Links already using .underlineAnimate / .lm-ul keep their own effect.
   Finds links underlined with text-decoration and moves the underline into ::after (class lm-lift). */
(function () {
  var SKIP = '.underlineAnimate, .lm-ul, .lm-lift, .lm-lift-skip, .btn, .button, .header__icon, .list-social__link, .boost-sd__pagination-number, .store-cookies, [class*="boost-sd"], [class*="swym"], [id^="swym"], klarna-placement, .sp-kiwi-sizechart, .menu-drawer__menu-item, .menu-drawer__close-button, .menu-drawer__navigation summary';
  /* perf (22 Oct): cheapest tests first; most links (menus, footer, cards) are not underlined and drop out
     at the computed-style check before the costly selector and text lookups */
  function eligible(el) {
    var text = (el.textContent || '').trim();
    if (!text || text.length > 80) return false;
    var s = getComputedStyle(el);
    if ((s.textDecorationLine || s.textDecoration || '').indexOf('underline') === -1) return false;
    if (el.closest(SKIP) || el.querySelector('img, svg, picture, video, .underlineAnimate, .lm-ul')) return false;
    /* links inside running text (a sentence with more words around the link) keep their normal underline */
    var parentText = (el.parentElement && el.parentElement.textContent || '').trim();
    if (parentText.length > text.length + 20) return false;
    /* only links that sit on one line (no wrapping inside long running text) */
    var rects = el.getClientRects();
    return rects.length === 1;
  }
  function wrap(el) {
    var span = document.createElement('span');
    span.className = 'lm-lift__t';
    while (el.firstChild) span.appendChild(el.firstChild);
    el.appendChild(span);
    el.classList.add('lm-lift');
  }
  /* perf (22 Oct): read all layout values first, then change the DOM, so the browser lays out the page once
     instead of once per link (was ~0.3 s on phones) */
  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    var list = root.querySelectorAll('a[href], button.link, a[data-drawer], span.underline-link'), hits = [];
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.classList.contains('lm-lift') || el.offsetParent === null) continue;
      if (eligible(el)) hits.push(el);
    }
    for (var j = 0; j < hits.length; j++) wrap(hits[j]);
  }
  var t, pending = [];
  function later() { clearTimeout(t); t = setTimeout(function () { var roots = pending.splice(0); roots.forEach(function (r) { if (r.isConnected) scan(r); }); }, 250); }
  function start() {
    /* first scan right at start-up, before the page settles: running it later (idle) turned links into
       inline-block after the first paint and made the page jump (CLS) */
    scan(document);
    /* only rescan what was added (never the whole page), and never inside app-rendered UIs (Boost/Swym are React) */
    new MutationObserver(function (recs) {
      recs.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1 && !n.closest(SKIP)) pending.push(n.parentElement || n); }); });
      if (pending.length) later();
    }).observe(document.body, { childList: true, subtree: true });
    /* links in drawers/accordions are hidden (offsetParent null) at load: rescan when something opens */
    /* drawers/accordions open on click: rescan only the opened area */
    function opened() {
      document.querySelectorAll('.site-drawer.open, .site-drawer.active, details[open], .drawer.active, .menu-drawer, .collapse-content-row').forEach(function (r) { if (!r.closest(SKIP)) pending.push(r); });
      later();
    }
    document.addEventListener('click', function () { setTimeout(opened, 60); setTimeout(opened, 600); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* live-match (Robin 21 Oct, mobile menu):
   1) tapped menu links turn bold right away, so the user sees the tap registered;
   2) a thin always-visible scroll indicator on the right of long menu lists (iOS hides native scrollbars). */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.menu-drawer a, .menu-drawer summary');
    if (!a) return;
    document.querySelectorAll('.menu-drawer .lm-tapped').forEach(function (x) { x.classList.remove('lm-tapped'); });
    a.classList.add('lm-tapped');
  }, true);

  function bar(sc) {
    var host = sc.parentElement; if (!host) return null;
    var b = host.querySelector(':scope > .lm-sbar');
    if (!b) {
      b = document.createElement('div'); b.className = 'lm-sbar';
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(b);
    }
    return b;
  }
  function update(sc) {
    if (!sc || !sc.isConnected) return;
    var b = bar(sc); if (!b) return;
    var ch = sc.clientHeight, sh = sc.scrollHeight;
    var subOpen = sc.classList.contains('mob-menu-drawer-wrapper') && sc.querySelector('details[open] > .menu-drawer__submenu');
    if (subOpen || !ch || sh <= ch + 4 || !sc.offsetParent) { b.style.display = 'none'; return; }
    /* the bar runs below the sticky submenu header (e.g. "◀ BRANDS"), not over it */
    var head = sc.querySelector('.menu-drawer__close-button');
    var hh = head && head.offsetParent ? head.offsetHeight : 0;
    var track = ch - hh;
    var h = Math.max(30, track * ch / sh);
    var top = sc.offsetTop + hh + (sc.scrollTop / (sh - ch)) * (track - h);
    b.style.display = 'block'; b.style.height = h + 'px'; b.style.top = top + 'px';
  }
  var SEL = '.menu-drawer__inner-submenu > .menu-drawer__menu, .mob-menu-drawer-wrapper';
  /* opening a submenu (e.g. BRANDS): bring the outer menu back to the top, so the submenu panel sits right under
     the search bar and only the submenu list scrolls (outer scrolling is locked in live-match-global.css) */
  document.addEventListener('click', function (e) {
    var sm = e.target.closest && e.target.closest('.menu-drawer summary');
    if (!sm) return;
    setTimeout(function () { var w = sm.closest('.mob-menu-drawer-wrapper'); if (w) w.scrollTop = 0; }, 0);
  }, true);
  function all() { document.querySelectorAll(SEL).forEach(update); }
  document.addEventListener('scroll', function (e) { if (e.target.matches && e.target.matches(SEL)) update(e.target); }, true);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.menu-drawer, .header__icon--menu, summary')) { setTimeout(all, 50); setTimeout(all, 400); } }, true);
  window.addEventListener('resize', all);
})();

/* live-match (Robin 21 Oct, iOS): the page may zoom in while typing in a search field; when the search is sent
   (Enter / search key / search icon) close the keyboard and return to the normal 100% view. */
(function () {
  var vp = document.querySelector('meta[name="viewport"]');
  function resetZoom() {
    if (!vp) return;
    var orig = vp.getAttribute('content');
    vp.setAttribute('content', orig.replace(/,?\s*maximum-scale=[^,]*/, '') + ',maximum-scale=1');
    setTimeout(function () { vp.setAttribute('content', orig); }, 400);
  }
  /* shared: close the keyboard and return to 100% (used by the newsletter and notify-me forms) */
  window.lmResetZoom = function () { if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); resetZoom(); };
  function isSearch(el) { return el && el.matches && el.matches('input[type="search"], input[name="q"], .mob-drawer-search-input, .search__input'); }
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.keyCode === 13) && isSearch(e.target)) { e.target.blur(); resetZoom(); }
  }, true);
  document.addEventListener('submit', function (e) { if (e.target.querySelector && e.target.querySelector('input[type="search"], input[name="q"]')) { if (document.activeElement) document.activeElement.blur(); resetZoom(); } }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[type="submit"], .search__button, .mob-drawer-search-btn, [class*="search"] button');
    if (b && b.closest('form, [class*="search"]')) { if (document.activeElement && isSearch(document.activeElement)) document.activeElement.blur(); resetZoom(); }
  }, true);
})();

/* live-match (Robin 21 Oct): size-chart country headers abbreviated on phones so the first
   column fits on one row (INTERNATIONAL -> INT, ITALY -> IT, JAPAN -> JP ...). Kiwi table only. */
(function () {
  var MAP = { 'INTERNATIONAL': 'INT', 'INTERNATIONAL SIZE': 'INT', 'ITALY': 'IT', 'ITALIEN': 'IT', 'ITALIA': 'IT', 'JAPAN': 'JP', 'JAPON': 'JP',
    'FRANCE': 'FR', 'FRANKREICH': 'FR', 'GERMANY': 'DE', 'DEUTSCHLAND': 'DE', 'EUROPE': 'EU', 'EUROPA': 'EU',
    'UNITED KINGDOM': 'UK', 'GREAT BRITAIN': 'UK', 'USA': 'US', 'UNITED STATES': 'US', 'KOREA': 'KR', 'CHINA': 'CN' };
  /* shoe charts (Robin 22 Oct): "S/M/L" in the Kiwi shoe charts is really the EU size; "SHOES US/UK/JP" -> US/UK/JP (all widths) */
  var ALWAYS = { 'CROTCH': 'RISE', 'S/M/L': 'EU', 'SHOES EU': 'EU', 'SHOES US': 'US', 'SHOES UK': 'UK', 'SHOES JP': 'JP', 'SHOES IT': 'IT' };
  var mq = window.matchMedia('(max-width: 767px)');
  function run() {
    var cells = document.querySelectorAll('#eusizeChart td, #eusizeChart th, .sp-kiwi-sizechart td, .sp-kiwi-sizechart th');
    for (var i = 0; i < cells.length; i++) {
      var c = cells[i];
      if (c.children.length > 1) continue;
      var full = c.getAttribute('data-lm-full') || c.textContent.replace(/\s+/g, ' ').trim();
      var key = full.toUpperCase().replace(/\s+/g, ' ');
      var always = ALWAYS[key];
      var ab = always || MAP[key];
      if (!ab) continue;
      if (!c.hasAttribute('data-lm-full')) { c.setAttribute('data-lm-full', full); c.setAttribute('title', full); }
      var want = ab; /* Robin 22 Oct: abbreviations on all screen sizes */
      var t = c.children.length === 1 ? c.children[0] : c;
      if (t.textContent !== want) t.textContent = want;
      c.style.whiteSpace = 'nowrap';
    }
  }
  function later() { run(); setTimeout(run, 400); setTimeout(run, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
  window.addEventListener('load', later);
  if (mq.addEventListener) mq.addEventListener('change', run);
  /* Kiwi may (re)render the table at any time: watch the size drawer and re-apply */
  var pend = 0;
  function watch() {
    var d = document.getElementById('eusizeChart');
    if (!d || d.__lmAbbr) return;
    d.__lmAbbr = 1;
    new MutationObserver(function () { if (pend) return; pend = requestAnimationFrame(function () { pend = 0; run(); }); })
      .observe(d, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-drawer="eusizeChart"], .measure-info-toggle, #eusizeChart')) later();
  }, true);
})();

/* live-match (Robin 22 Oct): Boost product cards show the hover size row also for single-variant items
   (Boost's card template only renders it when there is more than one variant). "Default Title" -> UNI. */
(function () {
  var cache = {};
  function label(v) { var t = String(v.title || '').split('/')[0].trim(); return (!t || t === 'Default Title') ? 'UNI' : t; }
  function build(card, d) {
    if (card.querySelector('.custom-pro-variant-wrapper')) return;
    var price = card.querySelector('.boost-sd__product-price'); if (!price) return;
    var w = document.createElement('div');
    w.className = 'custom-pro-variant-wrapper lm-uni';
    var inn = document.createElement('div'); inn.className = 'custom-pro-variant-in';
    var a = document.createElement('a');
    a.className = 'custom-pro-variant-item' + (d.available ? '' : ' soldout');
    a.href = d.href; a.textContent = d.label;
    inn.appendChild(a); w.appendChild(inn); price.appendChild(w);
  }
  function handle(card) {
    if (card.__lmUni) { if (card.__lmUni !== 1) build(card, card.__lmUni); return; }
    if (card.querySelector('.custom-pro-variant-wrapper')) { card.__lmUni = 1; return; }
    var link = card.querySelector('a.boost-sd__product-link[href*="/products/"]');
    if (!link) return;
    card.__lmUni = 1;
    var path = new URL(link.getAttribute('href'), location.href).pathname.replace(/\/$/, '');
    var p = cache[path] || (cache[path] = fetch(path + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
    p.then(function (prod) {
      if (!prod || !prod.variants || prod.variants.length !== 1) return;
      var v = prod.variants[0];
      card.__lmUni = { label: label(v), href: path + '?variant=' + v.id, available: !!v.available };
      build(card, card.__lmUni);
    });
  }
  var queued = false;
  function scan() {
    queued = false;
    var cards = document.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < cards.length; i++) handle(cards[i]);
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(scan); } }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  queue();
})();

/* live-match (Robin 22 Oct): newsletter curtain signs up without leaving the page. The curtain stays open and shows
   "You're almost done! ... confirm your subscription" (template in snippets/newsletter-form.liquid). If Shopify asks for a
   captcha (or anything unexpected happens) the form is sent the normal way instead. */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector || !form.querySelector('.lm-nl-drawer')) return;
    var tpl = form.querySelector('template.lm-nl-success-tpl');
    if (!tpl || !window.fetch || !window.FormData) return;
    e.preventDefault();
    if (window.lmResetZoom) window.lmResetZoom();
    var btn = form.querySelector('.newsletter-btn');
    var label = btn ? btn.value : '';
    if (btn) { btn.disabled = true; btn.value = '…'; }
    fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (/\/challenge/.test(r.url)) throw new Error('challenge');
        return r.text().then(function (html) {
          var ok = /customer_posted=true/.test(r.url) || /newsletter-succues-div/.test(html) && !/class="errors"/.test(html);
          if (!ok) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var err = doc.querySelector('#newsletter-drawer .errors, .lm-nl-drawer .errors');
            if (!err) throw new Error('unknown');
            var box = form.querySelector('.lm-nl-drawer .errors');
            if (!box) { box = document.createElement('div'); box.className = 'errors'; var intro = form.querySelector('.lm-nl-intro'); intro && intro.parentNode.insertBefore(box, intro.nextSibling); }
            box.innerHTML = err.innerHTML;
            if (btn) { btn.disabled = false; btn.value = label; }
            return;
          }
          var wrap = form.querySelector('.lm-nl-drawer');
          wrap.innerHTML = '';
          wrap.appendChild(tpl.content.cloneNode(true));
        });
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.value = label; } HTMLFormElement.prototype.submit.call(form); });
  }, true);
})();

/* live-match (Robin 22 Oct): phone menu search - tapping "Looking for something?" opens the search screen with the
   field already active (no second tap). Runs after the theme's own handler has opened the search screen. */
(function () {
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#predictive-search-input, .mob-search-icon, .predictive-search-wrap.mobile-predictive')) return;
    var i = document.querySelector('#mobile-search-blocks .mob-drawer-search-input');
    if (!i) return;
    try { i.focus({ preventScroll: true }); } catch (er) { i.focus(); }
    setTimeout(function () { if (document.activeElement !== i) { try { i.focus({ preventScroll: true }); } catch (er) {} } }, 60);
  });
})();

/* live-match (Robin 22 Oct): mobile collection pages - after changing page, show the new page from the top
   (Boost swaps the products in place, so the visitor stayed at the bottom). */
(function () {
  var mq = window.matchMedia('(max-width: 1024px)');
  function firstId() {
    var c = document.querySelector('.boost-sd__product-item, .boost-sd__product-list > *');
    return c ? (c.getAttribute('data-product-id') || c.id || (c.querySelector('a[href]') || {}).href || c.textContent.slice(0, 80)) : '';
  }
  function toTop() { window.scrollTo(0, 0); document.documentElement.scrollTop = 0; document.body.scrollTop = 0; }
  document.addEventListener('click', function (e) {
    if (!mq.matches || !e.target.closest) return;
    var b = e.target.closest('.boost-sd__pagination-number, .boost-sd__pagination-button, .boost-sd__pagination a, .boost-sd__pagination button');
    if (!b || b.disabled || b.classList.contains('boost-sd__pagination-number--active')) return;
    var before = firstId(), n = 0;
    (function wait() {
      n++;
      if (firstId() !== before || n > 40) { toTop(); setTimeout(toTop, 150); return; }
      setTimeout(wait, 75);
    })();
  });
})();
